import styled from 'styled-components';

const icon = ($name, $width, $height) => {
  return `
  display: inline-block;
  width: ${$width}px;
  height: ${$height}px;
  background: url(${require(`./images/icon-${$name}.png`)}) no-repeat;
  background-size: contain;
  `;
};

const PopupWrap = styled.div`
  position: absolute;
  top: 60px;
  right: -10px;
  width: 285px;
  // height: 420px;
  background: #fff;
  border-radius: 6px;
  z-index: ${(props) => props.theme.zIndex.floatPopup};
  line-height: 1;

  &::after {
    position: absolute;
    top: -7px;
    right: 25px;
    content: ' ';
    width: 17px;
    height: 8px;
    background: url(${require('./images/icon-top-arrow.png')}) no-repeat center;
  }

  .popup-top {
    //height: 214px;
    padding: 16px 0;
    background: #2d2d2d;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    text-align: center;
    color: #999;

    &-img {
      display: block;
      width: 64px;
      height: 64px;
      border-radius: 50%;
      margin: 0 auto 16px;
    }

    .user-online-switch {
      position: relative;
      width: 46px;
      height: 16px;
      margin: -26px auto 8px;
      line-height: 16px;
      font-size: 10px;
      color: #333;
      background-color: #ececec;
      border-radius: 8px;
      cursor: pointer;

      .status-online,
      .status-hiding {
        width: 46px;
        height: 16px;
      }

      &.online {
        .status-online {
          display: block;
        }

        .status-hiding {
          display: none;
        }
      }

      > div {
        display: none;

        &.status-hiding {
          display: block;
        }

        i {
          float: left;
          margin: 2px 3px;
        }

        span {
          float: left;
        }
      }

      .icon-user-online {
        display: inline-block;
        width: 12px;
        height: 12px;
        background-color: #40db2b;
        border-radius: 50%;
      }

      .icon-user-hiding {
        ${icon('hiding', 12, 12)};
      }

      .status-popup-switch {
        position: absolute;
        left: 48px;
        top: 0;
        width: 70px;
        height: 56px;
        background-color: #fff;
        border-radius: 4px;

        li {
          height: 28px;
          line-height: 28px;
          display: flex;
          align-content: center;
          align-items: center;
          cursor: pointer;
          border-top-right-radius: 4px;
          border-top-left-radius: 4px;

          &.active .icon-select {
            visibility: visible;
          }

          &:last-child {
            border-bottom-right-radius: 4px;
            border-bottom-left-radius: 4px;
          }

          &:hover {
            background-color: #488ef7;
            color: #fff;

            .icon-select {
              ${icon('selected-active', 10, 7)};
            }
          }

          > * {
            margin: 0 0 0 5px;
          }
        }

        .icon-select {
          visibility: hidden;
          ${icon('selected', 10, 7)};
        }
      }
    }

    .user-nickname {
      margin: 0 0 4px;
      font-size: 14px;
      color: #fff;
    }

    .user-id {
      margin: 0 0 4px;
      color: ${(props) => props.theme.color.grayLight};
    }

    .user-level {
      padding: 0 0 20px;
    }

    .user-coin-bean {
      margin: 0 0 9px;
      line-height: 18px;
      color: ${(props) => props.theme.color.grayLight};

      .user-coin-count {
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .icon-user-coin {
        ${icon('coin', 18, 18)}
      }

      .icon-user-bean {
        ${icon('vc', 18, 18)}
      }

      .spliter {
        float: left;
        width: 1px;
        height: 14px;
        margin: 2px 0 0;
        background-color: ${(props) => props.theme.color.grayLight};
      }

      span {
        margin-left: 8px;
      }
    }

    .btn {
      padding: 0;
      width: 90px;
      height: 30px;
      line-height: 30px;
      font-size: 14px;
    }
  }

  .popup-bottom {
    .icon-user-center {
      ${icon('user-center', 18, 18)};
      margin-right: 10px;
    }

    .icon-home-page {
      ${icon('home-page', 16, 20)};
      margin-right: 11px;
    }

    .icon-family {
      ${icon('family', 18, 18)};
      margin-right: 10px;
    }

    .icon-pay-log {
      ${icon('consume-log', 15, 18)};
      margin-right: 11px;
    }

    .icon-guild-income {
      display: inline-block;
      width: 20px;
      height: 20px;
      background: url(${require(`./images/icon-broker-income.png`)}) no-repeat;
      background-size: contain;
      margin-right: 7px;
    }

    .icon-sign-entry {
      ${icon('sign-entry', 18, 18)};
      margin-right: 8px;
    }

    .icon-apply-live {
      ${icon('apply-live', 22, 15)};
      margin-right: 8px;
    }

    > div {
      margin: 13px 0 0;

      a {
        float: left;
        display: flex;
        align-content: center;
        align-items: center;
        justify-content: center;
        width: 50%;
        height: 30px;
        margin: 0 0 10px;
        line-height: 30px;
        color: #666666;
        box-sizing: border-box;
        padding-left: 30px;

        &:hover {
          text-decoration: underline;
        }
        span {
          flex: auto;
        }
      }
    }
  }

  .user-logout-btn {
    display: flex;
    align-content: center;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 39px;
    line-height: 39px;
    text-align: center;
    border-top: 1px solid #ebebeb;
    color: ${(props) => props.theme.color.grey};

    .icon-logout {
      ${icon('logout', 14, 15)};
      margin: 0 8px 0 0;
    }

    &:hover {
      .icon-logout {
        ${icon('logout-active', 14, 15)};
      }
    }
  }
`;

export default PopupWrap;
